import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Drawer from 'rmc-drawer';
import {Config} from 'constants/ThemeColors';
import SidenavContent from './SidenavContent';
import SidenavLogo from 'components/SidenavLogo';
import {COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION} from 'constants/ActionTypes';
import {toggleCollapsedNav, updateWindowWidth} from 'actions/Setting';
import {Form, FormGroup, Input} from 'reactstrap';

class DropdownSelect extends React.Component {
    constructor(props) {
        super(props);
        // this.state = {value: 'client'};
        this.handleChange = this.handleChange.bind(this);
        // this.handleSubmit = this.handleSubmit.bind(this);
      }
    
      handleChange(event) {
        this.props.onUserChange(event.target.value);
        // console.log(this.state.value)
      }
    
    //   handleSubmit(event) {
    //     alert('Your favorite flavor is: ' + this.state.value);
    //     event.preventDefault();
    //   }
    render() {
        const user = this.props.user;

        return (
            <Form>
                <FormGroup>
                <Input type="select" value={user} onChange={this.handleChange}>
                    {/* <Input type="select" name="select" id="exampleSelect"> */}
                        <option value='broker'>Broker</option>
                        <option value='agent'>Agent</option>
                        <option value='client'>Client</option>
                </Input>
                </FormGroup>
            </Form>
        );
    }
}
 
class SideNav extends React.PureComponent {

    onToggleCollapsedNav = (e) => {
        const val = !this.props.navCollapsed;
        this.props.toggleCollapsedNav(val);
    };

    constructor(props) {
        super(props);
        this.state = {user: 'broker'}
        this.handleUserChange = this.handleUserChange.bind(this);

    }

    handleUserChange(user) { 
        this.setState({user: user});

    }


    componentDidMount() {
        window.addEventListener('resize', () => {
            this.props.updateWindowWidth(window.innerWidth)
        });
    }

    render() {
        const user = this.state.user;
        const {navCollapsed, drawerType, width, isDirectionRTL, navigationStyle} = this.props;
        let drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-xl-flex' : drawerType.includes(COLLAPSED_DRAWER) ? '' : 'd-flex';
        let type = true;
        if (drawerType.includes(COLLAPSED_DRAWER) || (drawerType.includes(FIXED_DRAWER) && width < 1200)) {
            type = false;
        }
        if (navigationStyle===HORIZONTAL_NAVIGATION) {
            drawerStyle = "";
            type = false;
        }
  
        return (
            <Drawer docked={type} className={`app-sidebar ${drawerStyle}`}
                    style={{overflow: 'auto'}}
                    touch={true}
                    position={isDirectionRTL ? 'right' : 'left'}
                    transitions={true}
                    enableDragHandle={true}
                    open={navCollapsed}
                    onOpenChange={this.onToggleCollapsedNav}
                    sidebar={<div className="side-nav">
                        <SidenavLogo drawerType={drawerType}/>
                        <DropdownSelect user={user} onUserChange={this.handleUserChange}/> 

                        <SidenavContent user={user}/>
                    </div>}>
                <div/>
            </Drawer>
        );
    }
}

const mapStateToProps = ({settings}) => {
    const {navCollapsed, drawerType, width, isDirectionRTL, navigationStyle} = settings;
    return {navCollapsed, drawerType, width, isDirectionRTL, navigationStyle}
};

export default withRouter(connect(mapStateToProps, {toggleCollapsedNav, updateWindowWidth})(SideNav));



// WEBPACK FOOTER //
// ./containers/SideNav/index.js